import type { ChangelogEntry } from "../types";

/** Signalagentene stopper dubletter og utdaterte funn. */
export const SIGNALER_DUBLETTER_2026_10: ChangelogEntry = {
  id: "2026-10-25-signaler-dubletter",
  date: "2026-10-25",
  title: "Færre dubletter og ingen gamle nyheter i signalkøen",
  summary:
    "Samme funn med ny ordlyd blir ikke et nytt kort, og nyheter eldre enn 30 dager eller arrangementer som er over blir ikke signaler.",
  sections: [
    {
      heading: "Salgsmuligheter",
      minRole: "user",
      items: [
        {
          title: "Signalkøen rydder bort dubletter og gamle funn",
          kind: "rettet",
          featureFlag: "feature_crm_signaler",
          body: "Har kunden fått et kort av samme type fra samme side de siste 30 dagene, lages det ikke et nytt. Kort om nyheter publisert for over 30 dager siden, eller om en hendelse som allerede er over, slippes ikke gjennom.",
        },
      ],
    },
  ],
};
